import { Platform } from 'react-native';
import { appTheme } from '../../shared/theme';
import { androidScaleSize } from '../../shared/theme/androidUiParity';

/** Vertical padding above/below the journey wizard footer row (excluding safe-area inset). */
export const JOURNEY_FOOTER_VERTICAL_PAD = appTheme.spacing.lg;

/** Shared CTA height — footer buttons use `SolidCtaClickable` `size="compact"`. */
export const JOURNEY_FOOTER_CTA_HEIGHT = androidScaleSize(52);

/** Extra scroll breathing room below the last card (above the footer). */
export const JOURNEY_SCROLL_FOOTER_GAP = Platform.OS === 'android' ? appTheme.spacing.xl : appTheme.spacing.lg;

/** Progress meta row + track + `ScreenHeader` `bottomContent` padding — keep in sync with `JourneyProgressBar`. */
export const JOURNEY_PROGRESS_META_HEIGHT = androidScaleSize(22);
export const JOURNEY_PROGRESS_TRACK_HEIGHT = androidScaleSize(6);
export const JOURNEY_PROGRESS_HEADER_BLOCK_HEIGHT =
  appTheme.spacing.xs +
  JOURNEY_PROGRESS_META_HEIGHT +
  appTheme.spacing.sm +
  JOURNEY_PROGRESS_TRACK_HEIGHT +
  appTheme.spacing.sm;
